<p class="modal-title">Are you sure?</p>
<div class="modal-close" (click)="onClose()">
    <img alt="Close" src="../../../assets/icons/circle-x.svg" />
</div>
<p>
    Your HSA funds will stay in an FDIC-insured cash account if you choose "Non-investor" in the sliders. If you choose to invest your HSA funds, they can grow. So in retirement you could have more in your account to spend on healthcare, tax-free.
</p>
<div class="button-container">
    <button class="button filled-gray-button" (click)="wantToInvest(true)" (keyup.enter)="wantToInvest(true)" tabindex=0>ACTUALLY, I WANT TO INVEST</button>
    <button class="button filled-button" (click)="wantToInvest(false)" (keyup.enter)="wantToInvest(false)" tabindex=0>I'M SURE, I DON'T WANT TO INVEST</button>
</div>
